import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";

export const fetchLocations = async () => {
    const response = await apiFetch(`${API_BASE}/locations/client`);
    if (!response.ok) throw new Error("Не вдалося завантажити локації");
    return await response.json();
};
